import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleNavigation = async (e: React.MouseEvent, sectionId: string) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // Navigate to home page with the correct hash
      navigate(`/#${sectionId}`);
    } else {
      document.querySelector(`#${sectionId}`)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent, sectionId: string) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleNavigation(e as unknown as React.MouseEvent, sectionId);
    }
  };

  return (
    <footer 
      className="bg-gray-900"
      role="contentinfo"
      aria-label="Site footer"
    >
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <nav 
          className="flex flex-wrap justify-center space-x-6 md:space-x-12"
          aria-label="Footer navigation"
          role="navigation"
        >
          {['home', 'services', 'doctors', 'contact'].map((section) => (
            <a 
              key={section}
              href={`/#${section}`}
              className="text-gray-400 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-900 rounded-md px-2 py-1"
              aria-label={`Go to ${section} section`}
              onClick={(e) => handleNavigation(e, section)}
              onKeyPress={(e) => handleKeyPress(e, section)}
              role="menuitem"
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </a>
          ))}
        </nav>
        
        <div 
          className="mt-8 border-t border-gray-800 pt-8"
          role="contentinfo"
          aria-label="Legal information"
        >
          <p className="text-center text-gray-400 text-sm">
            © {currentYear} Metabolic & Primary Care Associates. All rights reserved.
          </p>
          <div className="mt-4 flex justify-center space-x-6">
            <Link 
              to="/privacy" 
              className="text-gray-400 hover:text-white text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-900 rounded-md px-2 py-1"
              aria-label="View privacy policy"
              onClick={() => window.scrollTo(0, 0)}
            >
              Privacy Policy
            </Link>
            <Link 
              to="/terms" 
              className="text-gray-400 hover:text-white text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-900 rounded-md px-2 py-1"
              aria-label="View terms of service"
              onClick={() => window.scrollTo(0, 0)}
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}